import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import {
  CLEAR_ALL_POLICIES_STATE,
  FETCH_ALL_POLICIES_LIST_FAILED,
  FETCH_ALL_POLICIES_LIST_PROGRESS,
  FETCH_ALL_POLICIES_LIST_SUCCESS,
  
} from "./PoliciesActions";
import { AllPoliciesActions } from ".";
import { initialPolicyState } from "./Policies.types";

export const AllPoliciesReducer = (
  state: IStoreState["allpolicies"] = initialPolicyState,
  action: AllPoliciesActions
) => {
  switch (action.type) {
    case FETCH_ALL_POLICIES_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.list = [];
        // draftState.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_ALL_POLICIES_LIST_SUCCESS: {
      const { list } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = list;
        // draftState.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_ALL_POLICIES_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.list = [];
        // draftState.totalRecords = 0;
      });
      return newState;
    }
    case CLEAR_ALL_POLICIES_STATE: {
      return initialPolicyState;
    }
    default: {
      return state;
    }
  }
};
